import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

/**
 * 定义 Footer 组件
 */
class Footer extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const {
            content: { nav, content },
        } = this.props;

        return (
            <div className={styles.phtv_footer}>
                <div className={styles.footer}>
                    <div style={{ float: 'left' }}>
                        <div className={styles.foot_link}>
                            <div className={styles.list}>
                                {nav.map((item, index) => (
                                    <a key={index} className={styles.link} href={item.url} target="_blank">
                                        {item.title}
                                    </a>
                                ))}
                            </div>
                        </div>
                        <div className={styles.copyright}>
                            <span>{content.text0}</span>
                            <span>{content.text1}</span>
                            <span>{content.text2}</span>
                        </div>
                    </div>
                    <div className={styles.footerR}>
                        <ul>
                            <li className={styles.f_ico1}>
                                <a href="http://v.ifeng.com/" target="_blank" title="视频">
                                    视频
                                </a>
                            </li>
                            <li>
                                ·<a href="http://v.ifeng.com/documentary/index.shtml" target="_blank" title="纪实">
                                    纪实
                                </a>
                            </li>
                            <li>
                                ·<a href="http://v.ifeng.com/live/" target="_blank" title="直播">
                                    直播
                                </a>
                            </li>
                            <li className={styles.f_ico2}>
                                <a href="http://phtv.ifeng.com/" target="_blank" title="凤凰卫视">
                                    凤凰卫视
                                </a>
                            </li>
                        </ul>
                        <a
                            href="http://phtv.ifeng.com/xinwen/detail_2014_07/07/37210520_0.shtml"
                            target="_blank"
                            className={styles.v_dellink}>
                            视频删帖申请流程
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Footer);
